import React from 'react';
import ReactCrop, { ReactCropProps } from 'react-image-crop';
import 'react-image-crop/dist/ReactCrop.css';

interface MuiReactImageCropProps extends Omit<ReactCropProps, 'children'> {
    src: string;
    onImageLoaded?: (image: HTMLImageElement) => void;
}

export const MuiReactImageCrop: React.FC<MuiReactImageCropProps> = ({ src, onImageLoaded, ...props }) => {
    const handleImageLoad = React.useCallback(
        (e: React.SyntheticEvent<HTMLImageElement>) => {
            if (onImageLoaded) {
                onImageLoaded(e.currentTarget);
            }
        },
        [onImageLoaded]
    );
    return (
        <ReactCrop {...props}>
            <img src={src} onLoad={handleImageLoad} style={{ maxWidth: '100%' }} />
        </ReactCrop>
    );
};
